export const CHECKBOX_COUNT_BREAKPOINT = 5;
